import { keyframes } from "@busbud/design-system-components/dist/styles/keyframes";

import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { breakpoints, spacing, styles, colors } = theme.busbud;

  const slideInUp = keyframes`
    from {
        opacity: 0;
        transform: translate3d(0, ${spacing(3)}, 0);
      }
  `;

  return {
    header: {
      padding: spacing(3, 3.5)
    },
    pageHeader: {
      padding: spacing(3.5, 0),
      animation: `${slideInUp} 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) 0.5s backwards`,
      "& .hide-back-btn": {
        visibility: "hidden"
      }
    },
    toolbar: {
      // needed to override layoutsection styles
      "&&": {
        paddingTop: spacing(1),
        [breakpoints.up("lg")]: {
          paddingTop: spacing(0)
        }
      }
    },
    loader: {
      display: "flex",
      justifyContent: "center"
    },
    firstSection: {
      borderBottom: `${styles.borderWidth.sm} solid ${colors.border.primary.opaque}`,
      [breakpoints.up("sm")]: {
        borderBottom: "none",
        borderRight: `${styles.borderWidth.sm} solid ${colors.border.primary.opaque}`
      }
    },
    cardContent: {
      paddingTop: 0
    }
  };
});
